var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showTagCloudInRecipeList
        ? _c("RecipeListKeywordCloud", {
            attrs: {
              keywords: _vm.rawKeywords,
              "filtered-recipes": _vm.filteredRecipes,
            },
            model: {
              value: _vm.keywordFilter,
              callback: function ($$v) {
                _vm.keywordFilter = $$v
              },
              expression: "keywordFilter",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "recipes-submenu-container",
          attrs: { id: "recipes-submenu" },
        },
        [
          _vm.recipes.length > 0
            ? _c(
                "Multiselect",
                {
                  staticClass: "recipes-sorting-dropdown",
                  attrs: {
                    multiple: false,
                    searchable: false,
                    placeholder: _vm.t("cookbook", "Select order"),
                    options: _vm.recipeOrderingOptions,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "singleLabel",
                        fn: function (props) {
                          return [
                            _c("span", {
                              staticClass: "ordering-item-icon",
                              class: props.option.icon,
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "option__title" }, [
                              _vm._v(_vm._s(props.option.label)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "option",
                        fn: function (props) {
                          return [
                            _c("span", {
                              staticClass: "ordering-item-icon",
                              class: props.option.icon,
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "option__title" }, [
                              _vm._v(_vm._s(props.option.label)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    758148566
                  ),
                  model: {
                    value: _vm.orderBy,
                    callback: function ($$v) {
                      _vm.orderBy = $$v
                    },
                    expression: "orderBy",
                  },
                },
                [
                  _c("template", { slot: "placeholder" }, [
                    _c("span", {
                      staticClass: "icon-triangle-n",
                      staticStyle: { "margin-right": "-8px" },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "ordering-item-icon icon-triangle-s",
                    }),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.t("cookbook", "Select order")) +
                        "\n            "
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "recipes" },
        _vm._l(_vm.recipeObjects, function (recipeObj) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: recipeObj.show,
                  expression: "recipeObj.show",
                },
              ],
              key: recipeObj.recipe.recipe_id,
            },
            [_c("RecipeCard", { attrs: { recipe: recipeObj.recipe } })],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }